<template>
    <div class="menu">
        <div class="box_left" :style="`height:${height}px`">
            <ul v-if="menuList && menuList.length > 0">
                <template v-for="item in menuList">
                    <li :key="item.jurId" @click="tabClick(item)" :class="{ 'li_active': item.jurId == menuObj.jurId }" v-if="item.list.length > 0">
                        <span>
                            <span v-if="item.jurImg" :class="`iconfont ${item.jurImg} icons`" style="margin-right: 5px;"></span>
                            <span>{{ item.jurName }}</span>
                        </span>
                        <i class="el-icon-arrow-right left_icon"></i>
                    </li>
                </template>
            </ul>
        </div>
        <div class="box_right" :style="`height:${height}px`">
            <ul class="box_ul" v-if="menuObj && menuObj.list.length > 0">
                <template v-for="item in menuObj.list">
                    <li class="box_li" :key="item.jurId" v-if="item.jurName == '我的收藏' || item.jurName == '常用功能' || item.jurName == '历史记录' || item.list.length > 0">
                        <h4>{{ item.jurName }}</h4>
                        <ul v-if="item.list.length > 0">
                            <li v-for="val in item.list" :key="val.jurId">
                                <span class="content">
                                    <span @click="tabItemClick(val)" style="display: inline-block; width: 20px;height: 20px;text-align: center;">
                                        <span v-if="val.jurImg" :class="`iconfont ${val.jurImg} icons`"></span>
                                    </span>
                                    <span @click="tabItemClick(val)">{{ val.jurName }}</span>
                                    <span class="collect">
                                        <i style="font-size: 17px;" v-if="val.isOften == 0 || val.isOften == null" class="el-icon-star-off collect_icons" @click.stop="collectionMenu(val)"></i>
                                        <i style="font-size: 17px;" v-else class="el-icon-star-on" @click.stop="collectionMenu(val)"></i>
                                    </span>
                                </span>
                            </li>
                        </ul>
                        <el-empty v-else :image-size="100" :description="item.jurName == '我的收藏' ? '暂无收藏' : item.jurName == '常用功能' ? '暂无数据' : '暂无记录'"></el-empty>
                    </li>
                </template>
            </ul>
            <el-empty v-else :image-size="100" description="暂无权限"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: "functionMenu",
    data() {
        return {
            userMenuList: [],
            menuList: [],
            menuObj: {
                jurId: -1,
                list: [],
            },
            height: 100,
            menuItem: {
                jurId: -1,
                list: [
                    {
                        jurName: '我的收藏',
                        list: [],
                    },
                    {
                        jurName: '常用功能',
                        list: [],
                    },
                    {
                        jurName: '历史记录',
                        list: [],
                    },
                ],
                jurName: "我的",
                jurImg: "iconshouye"
            }
        }
    },
    created() {
        if (sessionStorage.getItem("webMenuList")) {
            this.menuList = JSON.parse(sessionStorage.getItem("webMenuList"))
            this.menuList.unshift(this.menuItem)
            this.getUserMenu(true);
        }
    },
    methods: {
        openBox() {
            this.menuRecordQueryConstantRecord()
            this.menuRecordQueryHisRecord()
            this.$nextTick(() => {
                setTimeout(() => {
                    this.heightChange()
                }, 100)
            })
        },
        heightChange() {
            this.$nextTick(() => {
                var boxHeight = document.documentElement.clientHeight
                var headHeight = document.documentElement.querySelector("#elHeader").clientHeight
                var tabHeight = document.documentElement.querySelector(".el-tabs__header").clientHeight
                this.height = boxHeight - (headHeight + tabHeight)
            })
        },
        tabClick(val) {
            if (val.jurId != this.menuObj.jurId) {
                if (val.jurName == '我的') {
                    this.menuRecordQueryConstantRecord()
                    this.menuRecordQueryHisRecord()
                }
                this.menuObj = val
                document.documentElement.querySelector('.box_right').scroll(0, 0)
            }
        },
        tabItemClick(val) {
            this.$emit('menuClick', val)
        },
        // 收藏菜单
        async collectionMenu(val) {
            let responseData = await this.$http.collectionMenu({
                ids: [val.jurId]
            });
            if (responseData.status == 200) {
                if (val.isOften == 1) {
                    val.isOften = 0
                } else {
                    val.isOften = 1
                }
                this.getUserMenu(false);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                if (value["jurParentid"] == id) {
                    if (value["urlStype"] == 1) {
                        value["selectedStatus"] = 0;
                    }
                    value["list"] = this.handleJurisdiction(
                        data,
                        value["jurId"],
                        lev + 1
                    );

                    son.push(value);
                }
            });
            return son;
        },
        // 获取用户收藏的菜单
        async getUserMenu(flag) {
            let responseData = await this.$http.getUserMenu({
                ids: [this.$store.getters.getUserInfo.opmId],
            });
            if (responseData.status == 200) {
                var arr = responseData.result;
                this.userMenuList = []
                var list = []
                if (sessionStorage.getItem('webList')) {
                    list = JSON.parse(sessionStorage.getItem('webList'))
                }
                list.forEach(item1 => {
                    item1.isOften = 0
                    arr.forEach(item => {
                        if (item.jurId == item1.jurId) {
                            item1.isOften = 1
                            this.userMenuList.push(item1)
                        }
                    })
                })
                this.menuList[0].list[0].list = this.userMenuList
                if (flag) {
                    this.menuObj = this.menuList[0]
                }
                this.openBox()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //常用功能
        menuRecordQueryConstantRecord() {
            this.$http.menuRecordQueryConstantRecord().then(res => {
                if (res.status == 200) {
                    if (res.result.length > 0) {
                        var arr = res.result
                        var list = []
                        var userList = []
                        if (sessionStorage.getItem('webList')) {
                            list = JSON.parse(sessionStorage.getItem('webList'))
                        }
                        arr.forEach(item => {
                            list.forEach(item1 => {
                                if (item.jurId == item1.jurId) {
                                    userList.push(item1)
                                }
                            })
                        })
                        userList.forEach(item => {
                            this.userMenuList.forEach(item1 => {
                                if (item.jurId == item1.jurId) {
                                    item.isOften = 1
                                }
                            })
                        })
                        this.menuList[0].list[1].list = userList
                    }
                }
            })
        },
        //历史记录
        menuRecordQueryHisRecord() {
            this.$http.menuRecordQueryHisRecord().then(res => {
                if (res.status == 200) {
                    if (res.result.length > 0) {
                        var arr = res.result
                        var list = []
                        var userList = []
                        if (sessionStorage.getItem('webList')) {
                            list = JSON.parse(sessionStorage.getItem('webList'))
                        }
                        arr.forEach(item => {
                            list.forEach(item1 => {
                                if (item.jurId == item1.jurId) {
                                    userList.push(item1)
                                }
                            })
                        })
                        userList.forEach(item => {
                            this.userMenuList.forEach(item1 => {
                                if (item.jurId == item1.jurId) {
                                    item.isOften = 1
                                }
                            })
                        })
                        this.menuList[0].list[2].list = userList
                    }
                }
            })
        },
    },
    mounted() {
        this.heightChange()
        window.addEventListener('resize', this.heightChange);
    },
    beforeDestroy() {
        // 移除绑定的listenResizeFn事件监听
        window.removeEventListener("resize", this.heightChange);
    }
}
</script>

<style scoped>
ul {
    list-style: none;
}

.menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box_left {
    padding: 10px 0;
    min-width: 180px;
    background-color: #e9eaf3;
    overflow: auto;
}

.box_right {
    padding: 20px 20px 10px 30px;
    width: 100%;
    background-color: #fff;
    overflow: auto;
}

.box_left::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.box_right::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.box_left::-webkit-scrollbar-track,
.box_right::-webkit-scrollbar-track {
    background-color: rgb(245, 245, 245);
}

.box_left ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    font-size: 15px;
    color: #262626;
    border-left: 5px solid #e9eaf3;
}

.box_left ul li .icons,
.box_right ul li .icons {
    color: #6f6f6f;
    font-weight: 700;
}

.box_left ul li:last-child {
    border-bottom: 1px solid transparent;
}

.box_left ul .li_active {
    color: #409eff;
    background-color: #ffffff;
    border-left: 5px solid #409eff;
}

.box_left ul li:hover {
    cursor: pointer;
    color: #409eff;
    background-color: #ffffff;
}

.box_left ul li .left_icon {
    font-size: 18px;
}

.box_right .box_ul .box_li ul {
    padding-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
}

.box_right .box_ul .box_li ul li {
    font-size: 15px;
    padding: 20px 20px 0 0px;
    color: #535353;
    width: 230px;
}

.box_right .box_ul .box_li ul li .content {
    display: flex;
    padding: 10px 0;
}

.box_right .box_ul .box_li ul li .content:hover {
    cursor: pointer;
    color: #409eff;
}

.box_right .box_ul .box_li ul li .content .collect {
    width: 25px;
    margin-left: 2px;
    display: inline-block;
}

.box_right .box_ul .box_li ul li .icons {
    font-size: 15px;
    font-weight: 700;
}

h4 {
    padding: 10px 0;
    border-bottom: 3px solid #e9eaf3;
}

.box_left ul .li_active .icons,
.box_left ul li:hover .icons,
.box_right .box_ul .box_li ul li .content:hover .icons {
    cursor: pointer;
    color: #409eff;
}

.box_right .box_ul .box_li ul li .collect_icons {
    display: none;
}

.box_right .box_ul .box_li ul li .content:hover .collect_icons {
    display: inline-block;
}
</style>